export const isDev = () => {
  try {
    return process.env.VERCEL_ENV === 'development' || process.env.VERCEL_ENV === 'preview';
  } catch {
    return true;
  }
};
